/**
 * In-app API booking (BookingModal, profile Bookings stat/modal) vs Nuitee whitelabel for everyone.
 *
 * When false: all users, including Cognito admins, use whitelabel; profile Bookings UI is hidden.
 * When true: Cognito admins use the API booking flow and see profile Bookings (for testing / staged rollout).
 *
 * Flip to true when the API flow is ready to replace whitelabel in production.
 */
export const ENABLE_IN_APP_API_BOOKING = false;

function readEnvFlag(value: string | undefined): boolean {
  if (!value) {
    return false;
  }
  const normalized = value.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

/**
 * GetYourGuide affiliate Partner ID from env. Public — embedded in outbound deep links.
 */
export function getGygPartnerId(): string | null {
  const value = process.env.NEXT_PUBLIC_GYG_PARTNER_ID;
  if (!value || typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Whether GYG experiences deep links/widgets are enabled.
 * Requires partner ID and NEXT_PUBLIC_ENABLE_GYG_EXPERIENCES=true.
 */
export function isGygExperiencesEnabled(): boolean {
  const partnerId = getGygPartnerId();
  if (!partnerId) {
    return false;
  }
  return readEnvFlag(process.env.NEXT_PUBLIC_ENABLE_GYG_EXPERIENCES);
}

/**
 * Stay22 affiliate ID from env. Public — embedded in outbound Allez links and Map iframes.
 */
export function getStay22Aid(): string | null {
  const value = process.env.NEXT_PUBLIC_STAY22_AID;
  if (!value || typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Whether Stay22 Allez deeplinks and Map embeds are enabled.
 * Requires AID and NEXT_PUBLIC_ENABLE_STAY22=true.
 */
export function isStay22Enabled(): boolean {
  const aid = getStay22Aid();
  if (!aid) {
    return false;
  }
  return readEnvFlag(process.env.NEXT_PUBLIC_ENABLE_STAY22);
}
